/** Maps API validation detail keys to institution create form data-auto-id values. */
const INSTITUTION_FIELD_TO_AUTO_ID: Record<string, string> = {
  institutionuuid: "institutionUuidInput",
  institutionrtid: "institutionRtIdInput",
  institutionenvironment: "institutionEnvironmentInput",
  consumernameproduct: "consumerNameProductInput",
  isdefault: "isDefaultCheckbox",
  businessunitid: "businessUnitIdInput",
};

function normalizeFieldKey(raw: unknown): string {
  return String(raw ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

function clearInstitutionFieldWarnings(root: ParentNode): void {
  for (const autoId of Object.values(INSTITUTION_FIELD_TO_AUTO_ID)) {
    const el = root.querySelector(`[data-auto-id='${autoId}']`);
    if (el) {
      el.removeAttribute("warning");
    }
  }
}

/**
 * Apply API validation details to matching form fields; return unmapped text for summary toast.
 */
export function applyInstitutionFieldErrors(
  root: ParentNode,
  details: Array<Record<string, unknown>> | undefined | null
): string {
  clearInstitutionFieldWarnings(root);
  if (!details?.length) {
    return "";
  }

  const unmapped: string[] = [];
  for (const detail of details) {
    const message = String(detail.description ?? detail.message ?? "").trim();
    if (!message) {
      continue;
    }

    const key = normalizeFieldKey(
      detail.code ?? detail.field ?? detail.property ?? detail.name
    );
    const autoId = key ? INSTITUTION_FIELD_TO_AUTO_ID[key] : undefined;

    if (autoId) {
      const el = root.querySelector(`[data-auto-id='${autoId}']`);
      if (el) {
        el.setAttribute("warning", message);
        continue;
      }
    }

    unmapped.push(message);
  }

  return unmapped.join("\n");
}

/** True when API details include a validation error for institutionUuid. */
export function hasInstitutionUuidValidationError(
  details: Array<Record<string, unknown>> | undefined | null
): boolean {
  if (!details?.length) {
    return false;
  }
  return details.some((detail) => {
    const key = normalizeFieldKey(
      detail.code ?? detail.field ?? detail.property ?? detail.name
    );
    return key === "institutionuuid";
  });
}
